module.exports = __webpack_public_path__ + "static/media/back_squat-01.9b5c7425.png";